import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import './plugins/base';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue2Filters from 'vue2-filters';
import Moment from 'moment';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import VueGtag from 'vue-gtag';
import Meta from 'vue-meta';

import { ApolloClient, HttpLink, ApolloLink, InMemoryCache } from 'apollo-boost';
import VueApollo from 'vue-apollo';

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process?.env?.VUE_APP_FIREBASE_API_KEY,
  authDomain: process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process?.env?.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process?.env?.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process?.env?.VUE_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

Vue.config.productionTip = false;

const config = Object.freeze({
  apiUrl: process.env.VUE_APP_API_URL,
});

window._ = require('lodash');

const plugin = {
  install(Vue, options) {
    Vue.prototype.$filters = Vue.options.filters;
    Vue.prototype.$eventHub = new Vue();
    Vue.prototype.$config = config;
    Vue.prototype.$moment = Moment;
  },
};

Vue.use(VueApollo);
Vue.use(VueSweetalert2);
Vue.use(Vue2Filters);
Vue.use(plugin);
Vue.use(Chartkick.use(Chart));
Vue.use(Meta, { refreshOnceOnNavigation: true });

const isProduction = process?.env?.NODE_ENV === 'production';
const gaMeasurementId = process?.env?.VUE_APP_GA_MEASUREMENT_ID;

if (!gaMeasurementId) {
  console.log('VUE_APP_GA_MEASUREMENT_ID NOT SET');
}

if (gaMeasurementId) {
  Vue.use(
    VueGtag,
    {
      config: { id: gaMeasurementId },
      appName: 'WitsRHI Service Finder',
      enabled: isProduction,
    },
    router
  );
}

const link = new HttpLink({ uri: config.apiUrl });

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  const token = localStorage.getItem('token');
  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  });
  // Call the next link in the middleware chain.
  return forward(operation);
});

const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
  cache,
  link: authLink.concat(link),
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.filter('getFormattedDate', value => {
  const ret = new Moment(value).format('YYYY-MM-DD HH:mm');
  return ret;
});

Vue.filter('getFormattedYYYYMMDD', value => {
  const ret = new Moment(value).format('YYYY-MM-DD');
  return ret;
});

Vue.filter('getFormattedYYYYMM', value => {
  const ret = new Moment(value).format('YYYY-MM');
  return ret;
});
//www.google.com/maps/dir//-26.205,28.047/@-26.205,28.047,17z
https: Vue.filter('getMapsLink', value => {
  return `<a target="_blank" href="https://www.google.com/maps/place/${value[1]},${value[0]}">View Location on Map</a>,
          <a target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${value[3]},${value[2]}&destination=${value[1]},${value[0]}">View Directions</a>`;
});

// import styles
import 'sweetalert2/dist/sweetalert2.min.css';
//import '@/assets/css/styles.css'

console.log(`SERVER: ${process?.env?.NODE_ENV ? process?.env?.NODE_ENV : 'NODE_ENV NOT SET'}`);
console.log(
  `API URL: ${
    process && process.env && process?.env?.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'VUE_APP_API_URL NOT SET'
  }`
);
if (!process?.env?.VUE_APP_FIREBASE_API_KEY) {
  console.log('VUE_APP_FIREBASE_API_KEY NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_AUTH_DOMAIN) {
  console.log('VUE_APP_FIREBASE_AUTH_DOMAIN NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_PROJECT_ID) {
  console.log('VUE_APP_FIREBASE_PROJECT_ID NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_STORAGE_BUCKET) {
  console.log('VUE_APP_FIREBASE_STORAGE_BUCKET NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_MESSAGE_SENDER_ID) {
  console.log('VUE_APP_FIREBASE_MESSAGE_SENDER_ID NOT SET');
} else if (!process?.env?.VUE_APP_FIREBASE_APP_ID) {
  console.log('VUE_APP_FIREBASE_APP_ID NOT SET');
}

new Vue({
  router,
  vuetify,
  apolloProvider,
  render: h => h(App),
}).$mount('#app');

try {
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event('app-rendered'));
  }
} catch (e) {
  // no-op
}
